import { useNotificationActions } from "~/shared/hooks/use-notifications.ts";

/**
 * Wrapper around {@link useNotificationActions} used throughout the
 * shipment-management feature. Notifications render as global toasts.
 */
export function useShipmentNotifications(): ReturnType<
	typeof useNotificationActions
> {
	return useNotificationActions();
}
